<template>
  <div class="player-panel"
    :style="panelStyle"
    @touchstart.passive="onTouchStart"
    @touchend.passive="onTouchEnd"
  >
    <div class="panel-header" ref="panelHeader">
      <div class="contentTab">
        <div
          :class="['menus', { active: active == item.groupValue }]"
          @click="menusHandle(item.groupValue)"
          v-for="(item, key) in menus"
          :key="key"
        >
          {{ item.groupText }}
        </div>
      </div>
    </div>
    <div class="panel-content" ref="panelContent">
      <div v-if="loading" class="loading-wrap">
        <van-loading type="spinner" color="#F80000" />
      </div>
      <div v-else class="mainContent">
        <div class="head">
          <div>{{ $t("home.footballer") }}</div>
          <div>{{ $t("home.team") }}</div>
          <div>{{ active == 2 ? $t("home.assist") : $t("home.goal") }}</div>
        </div>
        <div class="content">
          <div class="row" v-for="(item, key) in playerData" :key="key">
            <div style="padding-right: 10px">
              <span class="index">{{ key + 1 }}</span>
              <div class="imgWrap">
                <img v-if="item.ph" :src="item.ph" alt />
                <img
                  v-else
                  class="defaultHead"
                  :src="require('@/assets/imgs/comm/headDetault.svg')"
                  alt
                />
              </div>

              <span>{{ item.pnm }}</span>
            </div>
            <div>{{ item.tnm }}</div>
            <div>{{ active == 2 ? item.ast : item.gs }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlayerStatList } from "@/service/Player";
import { Loading } from "vant";
import { mapState } from "vuex";
import { getLang } from "../../utils/lng";

export default {
  name: "Player",
  components: {
    [Loading.name]: Loading,
  },
  data() {
    return {
      menus: [
        { groupValue: 1, groupText: this.$t("home.TopCcorer") },
        { groupValue: 2, groupText: this.$t("home.assists") },
      ],
      loading: true,
      active: 1,
      playerData: [],
      fetchTimer: null,
      // ---- 浮动面板 ----
      translateY: 313,
      isDragging: false,
      maxTranslateY: 0,
    };
  },
  created() {
    this.getPlayerStatList(true);
    // this.startQueue();
  },
  mounted() {
    this.$nextTick(() => {
      const parent = this.$el.parentElement;
      if (parent) {
        const parentTop = parent.getBoundingClientRect().top;
        this.maxTranslateY = parentTop - 44;
      } else {
        this.maxTranslateY = 313;
      }
      this.translateY = this.maxTranslateY;
      this.$el.addEventListener('touchmove', this.onTouchMove, { passive: false });
    });
  },
  destroyed() {
    clearInterval(this.fetchTimer);
    this.fetchTimer = null;
    if (this.$el) {
      this.$el.removeEventListener('touchmove', this.onTouchMove);
    }
  },
  computed: {
    panelStyle() {
      return {
        transform: `translateY(${this.translateY}px)`,
        transition: this.isDragging ? 'none' : 'none',
      };
    },
    expanded() {
      return this.translateY <= 0;
    },
    languageType() {
      return this.common.languageType;
    },
    ...mapState(["common"]),
  },
  methods: {
    // ---- 面板拖拽 ----
    onTouchStart(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
      this._startTranslateY = this.translateY;
      this._startContentScrollTop = this.$refs.panelContent?.scrollTop || 0;
      this.isDragging = true;
      this._draggingPanel = false;
      this._directionLocked = false;
      this._isHorizontal = false;
      document.body.style.overflow = 'hidden';
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const deltaX = currentX - this._startX;
      const deltaY = currentY - this._startY;

      if (!this._directionLocked) {
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          this._directionLocked = true;
          this._isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        } else {
          return;
        }
      }
      if (this._isHorizontal) return;

      const contentEl = this.$refs.panelContent;

      // 面板未展开 → 拖拽面板
      if (this._startTranslateY > 0) {
        e.preventDefault();
        this._draggingPanel = true;
        const newY = this._startTranslateY + deltaY;
        this.translateY = Math.max(0, Math.min(this.maxTranslateY, newY));
        return;
      }

      // 面板已展开，在内容顶部向下拖 → 收起面板
      if (this._startContentScrollTop <= 0 && deltaY > 0) {
        if (!this._draggingPanel && contentEl.scrollTop <= 0) {
          this._draggingPanel = true;
        }
        if (this._draggingPanel) {
          e.preventDefault();
          this.translateY = Math.max(0, Math.min(this.maxTranslateY, deltaY));
          return;
        }
      }
      // 其他情况: 正常滚动内容，不 preventDefault
    },
    onTouchEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.body.style.overflow = '';
      const deltaY = e.changedTouches[0].clientY - this._startY;
      if (deltaY > 0) {
        // 向下滑 → 想收起
        if (this.translateY > this.maxTranslateY * 0.1) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      } else {
        // 向上滑 → 想展开
        if (this.translateY > this.maxTranslateY * 0.9) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      }
    },
    // ---- 业务逻辑 ----
    menusHandle(val) {
      this.active = val;
      this.getPlayerStatList();
    },
    buildData(data) {
      let filedText = this.active == 1 ? "gs" : "ast";
      this.playerData = data.sort(
        (curr, next) => next[filedText] - curr[filedText]
      );
    },
    startQueue() {
      if (this.fetchTimer) {
        clearInterval(this.fetchTimer);
        this.fetchTimer = null;
      }
      this.fetchTimer = setInterval(() => {
        this.getPlayerStatList();
      }, 5000);
    },
    getPlayerStatList(firstLoad) {
      getPlayerStatList({
        languageType: getLang(this.languageType),
        type: this.active,
      }).then((res) => {
        if (res.success) {
          this.buildData(res.data);
        }
        setTimeout(() => {
          if (firstLoad) this.loading = false;
        }, 300);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.player-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100dvh - 44px);
  display: flex;
  flex-direction: column;
  background: var(--color-5);
  border-radius: 20px 20px 0 0;
  z-index: 10;
  will-change: transform;
}

.panel-header {
  flex-shrink: 0;
  user-select: none;
}

.contentTab {
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  background: var(--color-10);
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  .menus {
    height: 28px;
    line-height: 28px;
    flex: 1;
    text-align: center;
    background: var(--color-11);
    font-size: 14px;
    color: var(--text-dark-color);
    &:first-child {
      border-radius: 100px 0 0 100px;
    }
    &:last-child {
      border-radius: 0 100px 100px 0;
    }
  }
  .active {
    background: #F80000;
    color: #fff;
  }
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 80px;

  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
  }
}

.mainContent {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  color: #131a3e;
  border-radius: 8px;
  margin: 8px;
  background: var(--color-5);

  .head {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    background: #fbfbfb;
    text-align: left;
    position: relative;
    &::before {
      content: " ";
      position: absolute;
      width: 4px;
      left: 0px;
      top: 20%;
      bottom: 17.5%;
      border-radius: 0 5px 5px 0;
      background: #F80000;
    }
    & > div {
      &:first-child {
        flex: 1;
        padding-left: 23px;
      }
      &:nth-child(2) {
        width: 100px;
      }
      &:nth-child(3) {
        width: 48px;
        white-space: nowrap;
      }
    }
  }
  .content {
    flex: 1;
    .row {
      display: flex;
      align-items: center;
      height: 36px;
      padding: 7px 16px !important;
      box-sizing: border-box;

      background: #fff;
      border-bottom: 0.5px solid #edeef1;
      & > div {
        img {
          width: 23px;
          height: 23px;
          border-radius: 50%;
        }
        &:first-child {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .imgWrap {
            display: inline-block;
            text-align: center;
            line-height: 22px;
            border: 1px solid #edeef1;
            overflow: hidden;
            border-radius: 50%;
            margin: 0 8px;
            width: 24px;
            height: 24px;
            vertical-align: middle;
            .defaultHead {
              width: 17.45px;
              height: 17.45px;
            }
          }
          & > img {
            margin: 0 8px;
          }
          span {
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .index {
            font-family: "DIN";
            font-weight: 700;
            font-size: 12px;
            display: inline-block;
            vertical-align: middle;
            width: 15px;
            text-align: center;
          }
        }
        &:nth-child(2) {
          width: 100px;
          overflow: hidden;
          white-space: nowrap;
          padding-right: 10px;
          text-overflow: ellipsis;
        }
        &:nth-child(3) {
          width: 48px;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.dark{
  .player-panel {
  .contentTab {
    background: var(--color-10);
    .menus {
    }
    .active {
      background: #F80000;
      color: #fff;
    }
  }
  .mainContent {
    color: #fff;
    .head {
      background: none;
    }
    .content {
      .row {
        background: var(--color-10);
        border-bottom: 0.5px solid #2B2C30;
        & > div {
          &:first-child {
            .imgWrap {
              border: 1px solid #2B2C30;
            }
          }
        }
      }
    }
  }
}
}
</style>
